import React, { useEffect } from "react";
import styled from "styled-components";
import * as Auth from "../shared/styles";
import api from "api";
import { navigate } from "@reach/router";
import user from "containers/user";
import auth from "containers/auth";
import routes from "utils/absoluteRoutes";

const Container = styled(Auth.Container)`
  height: 100%;
  justify-content: center;
  @media screen and (max-width: 599px) and (orientation: portrait) {
    padding: 20% 0%;
  }
`;

const SigningInImage = styled.img`
  display: flex;
  margin: 0 auto;
  max-width: 40%;
  @media screen and (max-width: 599px) and (orientation: portrait) {
    max-width: 60%;
  }
`;

const SigningIn = (props) => {
  useEffect(() => {
    session();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  async function session() {
    const token = props.location?.href.split('access_token=')[1].split('&')[0]
    const now = new Date();
    const expiresAt = now.setHours(now.getHours() + 1);

    await auth.set({ token, expiresAt });
    const userDetails = await api.users.client.get();
    await user.set({ ...userDetails });
    navigate(routes.bizProfile);
  }

  return (
    <Container>
      <SigningInImage
        src={require("assets/images/signing-in.svg")}
        alt="Signing in..."
      />
    </Container>
  );
};

export default SigningIn;
